'use client';

import { createContext, useContext, type ReactNode } from 'react';
import { useRouter } from 'next/navigation';
import type { ParticipantAccount } from './sessions';

const ParticipantContext = createContext<ParticipantAccount | null>(null);

export function ParticipantProvider({
  participant,
  children,
}: {
  participant: ParticipantAccount | null;
  children: ReactNode;
}) {
  return (
    <ParticipantContext.Provider value={participant}>
      {children}
    </ParticipantContext.Provider>
  );
}

export function useParticipant() {
  return useContext(ParticipantContext);
}

export function useRequireParticipant() {
  const participant = useContext(ParticipantContext);
  const router = useRouter();

  if (!participant) {
    router.replace('/hub/login');
    return null;
  }

  return participant;
}
